import { SecondaryButton } from "../../buttons/secondaryButton";
import SearchIcon from "@mui/icons-material/Search";
import { CancelOutlined } from "@mui/icons-material";
import {
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  Hidden,
  Box,
  IconButton,
} from "@mui/material";
import React ,  {useState} from "react";
import { useNavigate  } from "react-router-dom";

const SearchComponent = () => {
  const router = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const handleStaffLoginClick = () => {
    router("/admin/signin");
  };
  const handleCloseSearch = () => {
    setSearchText("");
    setIsSearchClicked(false);
  };

  const handleChange = (event) => {
    event.preventDefault();
    setSearchText(event.target.value);
  };

  const handleSearchClick = (event) => {
    setIsSearchClicked(!isSearchClicked);
  };
  return (
    <Box sx={{ display: "flex", alignItems: "center" }} gap={{ md: 2, lg: 4 }}>
      {isSearchClicked ? (
        <FormControl sx={{ m: 1, width: "170px" }} variant="standard">
          <InputLabel htmlFor="standard-adornment-password">
            Search this page...
          </InputLabel>
          <Input
            id="standard-adornment"
            type={"text"}
            value={searchText}
            onChange={handleChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="search">
                  {isSearchClicked ? (
                    <CancelOutlined
                      onClick={handleCloseSearch}
                      sx={{
                        color: "#000",
                      }}
                      fontSize="small"
                    />
                  ) : (
                    <SearchIcon
                      color="primary"
                      sx={{
                        color: "#000",
                      }}
                      onClick={handleSearchClick}
                      fontSize="small"
                    />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      ) : (
        <IconButton>
          <SearchIcon color="primary" onClick={handleSearchClick} />
        </IconButton>
      )}

      <Hidden mdDown>
        <SecondaryButton text="Staff Login" onClick={handleStaffLoginClick} />
      </Hidden>
    </Box>
  );
};

export default SearchComponent;
